import { createSlice, createAsyncThunk, isAnyOf } from "@reduxjs/toolkit";
import { post, postFromData } from "../../services/api";   // your api.js
import ENDPOINTS from "../../utils/constants/endpoints";
import { logout } from './authSlice';
import { sessionPayload } from '../../utils/session';
import { getSchoolStaffReport } from '../../services/misReports';

// export const uploadDriverFile = async (file, type) => {
//   const token = localStorage.getItem("token");
// const {auth} =getState()
//   const formData = new FormData();
//   formData.append("token", token);
//   formData.append("users_id", auth?.user?.users_id);
//   formData.append("role_id", auth?.user?.role_id);
//   formData.append("images", file);

//   let endpoint = "";
//   if (type === "photo") endpoint = ENDPOINTS.DRIVER.UPLOAD_PHOTO;
//   if (type === "aadhaar") endpoint = ENDPOINTS.DRIVER.UPLOAD_AADHAAR;
//   if (type === "dl") endpoint = ENDPOINTS.DRIVER.UPLOAD_DL;

//   const response = await postFromData(endpoint, formData);
//   return response; // usually returns uploaded file URL
// };

export const uploadDriverFile = createAsyncThunk(
  "drivers/uploadDriverFile",
  async ({ file, type }, { getState, rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const { auth } = getState();   // 👈 works now

      const formData = new FormData();
      formData.append("token", token);
      formData.append("users_id", auth?.user?.users_id);
      formData.append("role_id", auth?.user?.role_id);
      formData.append("images", file);

      let endpoint = "";
      if (type === "photo") endpoint = ENDPOINTS.DRIVER.UPLOAD_PHOTO;
      if (type === "aadhaar") endpoint = ENDPOINTS.DRIVER.UPLOAD_AADHAAR;
      if (type === "dl") endpoint = ENDPOINTS.DRIVER.UPLOAD_DL;
      const response = await postFromData(endpoint, formData);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to upload file");
    }
  }
);

export const addDriver = createAsyncThunk(
  "drivers/addDriver",
  async (driverData, { rejectWithValue, getState }) => {
    try {
      const token = localStorage.getItem("token");
      const { auth } = getState()
      const payload = {
        token,
        users_id: auth?.user?.users_id,
        role_id: auth?.user?.role_id,
        ...driverData,
      }

      const response = await post(ENDPOINTS.DRIVER.ADD, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response;

    } catch (error) {
      return rejectWithValue(error.response.data || "Failed to add driver");
    }
  }
)

export const fetchDrivers = createAsyncThunk(
  "drivers/fetchDrivers",
  // usersId scopes the listing to another account; token and role_id always stay the logged-in
  // session's so the backend enforces access.
  async ({ usersId } = {}, { rejectWithValue, getState }) => {
    try {
      const token = localStorage.getItem("token");
      const { auth } = getState()
      const session = sessionPayload(auth);
      const response = await post(
        ENDPOINTS.DRIVER.LIST,
        {
          token,
          ...session,
          users_id: usersId ?? session.users_id,
          showlist_status: "0",
          limit: "0",
          format: "Json",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Always return an array
      if ((response?.status && response.status !== 'success') || !Array.isArray(response?.data)) throw new Error('Invalid driver listing response');
      return response.data;
    } catch (err) {
      // post() rethrows the response body, so a rejected session shows as the HTTP status or the body's status code.
      if (Number(err?.response?.status || err?.status_code || err?.status) === 401) return rejectWithValue({ sessionExpired: true });
      return rejectWithValue(err.response?.data || "Failed to fetch drivers");
    }
  }
);

// MIS School Details reads API/Reports/driver into the same list, so DriverDetails can open
// a reported person; its scope never equals a Driver/listing scope.
export const schoolReportScope = (schoolId) => `report:${schoolId}`;

export const fetchSchoolStaffReport = createAsyncThunk(
  "drivers/fetchSchoolStaffReport",
  async ({ schoolId }, { rejectWithValue }) => {
    try {
      return await getSchoolStaffReport(schoolId);
    } catch (err) {
      return rejectWithValue(err?.kind === "session" ? { sessionExpired: true } : { kind: err?.kind || "response" });
    }
  }
);

const start = (state, action, scope) => {
  state.requestId = action.meta.requestId;
  state.scope = scope;
  state.list = [];
  state.loading = true;
  state.error = null;
};

const driverSlice = createSlice({
  name: "drivers",
  initialState: {
    list: [],
    loading: false,
    error: null,
    // users_id the current list was requested for (or a schoolReportScope); null means the logged-in account's own listing.
    scope: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        state.list = [];
        state.loading = false;
        state.error = null;
        state.requestId = null;
        state.scope = null;
      })
      .addCase(fetchDrivers.pending, (state, action) => {
        start(state, action, action.meta.arg?.usersId ?? null);
      })
      .addCase(fetchSchoolStaffReport.pending, (state, action) => {
        start(state, action, schoolReportScope(action.meta.arg.schoolId));
      })
      .addMatcher(isAnyOf(fetchDrivers.fulfilled, fetchSchoolStaffReport.fulfilled), (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.list = action.payload;
        // Try to normalize to array
        //  const drivers = action.payload?.data?.driverMst;
        //  state.list = Array.isArray(drivers) ? drivers : [];
      })

      .addMatcher(isAnyOf(fetchDrivers.rejected, fetchSchoolStaffReport.rejected), (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default driverSlice.reducer;
